import * as betprofessor from './ForgotPassword.styles.betprofessor';
import * as betroyale from './ForgotPassword.styles.betroyale';
import * as fiestabet from './ForgotPassword.styles.fiestabet';
import * as puntcity from './ForgotPassword.styles.puntcity';
import * as questbet from './ForgotPassword.styles.questbet';
import * as sterlingparker from './ForgotPassword.styles.sterlingparker';
import * as vikingbet from './ForgotPassword.styles.vikingbet';
import * as volcanobet from './ForgotPassword.styles.volcanobet';
import * as juicybet from './ForgotPassword.styles.juicybet';
import * as goldenrush from './ForgotPassword.styles.goldenrush';
import * as forsport from './ForgotPassword.styles.forsport';
import * as junglebet from './ForgotPassword.styles.junglebet';
import * as oldgill from './ForgotPassword.styles.oldgill';
import * as sugarcastle from './ForgotPassword.styles.sugarcastle';
import * as buffalobet from './ForgotPassword.styles.buffalobet';
import * as titanbet from './ForgotPassword.styles.titanbet';
import * as bet777 from './ForgotPassword.styles.bet777';
import * as gigabet from './ForgotPassword.styles.gigabet';
import * as slambet from './ForgotPassword.styles.slambet';
import * as betstride from './ForgotPassword.styles.betstride';
import * as templebet from './ForgotPassword.styles.templebet';
import * as goldenbet888 from './ForgotPassword.styles.goldenbet888';
import * as hyperbet from './ForgotPassword.styles.hyperbet';
import * as chromabet from './ForgotPassword.styles.chromabet';
import * as bet575 from './ForgotPassword.styles.bet575';
import * as betblast from './ForgotPassword.styles.betblast';
import * as pyramidbet from './ForgotPassword.styles.pyramidbet';
import * as magnumbet from './ForgotPassword.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betprofessor,
  betroyale,
  fiestabet,
  puntcity,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  juicybet,
  goldenrush,
  forsport,
  junglebet,
  oldgill,
  sugarcastle,
  buffalobet,
  titanbet,
  bet777,
  gigabet,
  slambet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  chromabet,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
};
